import React from 'react';
import { FormattedMessage } from 'react-intl';
import { takeEvery, put, call } from 'redux-saga/effects';
import { setPluginTypeList } from 'domains/author/actions';
import { pushToast } from 'containers/ToastManager/actions';
import catchErrors from 'utils/commands/catchErrors';

import messages from '../messages';
import * as constants from '../constants';

export function* sendRequest(connection, action) {
  const { payload: { pluginType, pluginFilters } } = action;
  const authorPluginList = yield call(connection.fetch.bind(connection), {
    type: constants.RTM_AUTHOR_PLUGIN_LIST,
    pluginType,
    ...(pluginFilters && ({ pluginFilters })),
  });
  if (authorPluginList.type === constants.RTM_AUTHOR_PLUGIN_LIST_OK) {
    const plugins = authorPluginList.response.plugins;
    yield put(setPluginTypeList(pluginType, plugins));
  } else {
    yield put(pushToast({
      type: 'simple',
      message: <FormattedMessage {...messages.failedAuthorPluginListFetch} />,
    }));
  }
}

export default function* (connection) {
  yield takeEvery(constants.COMMAND_AUTHOR_PLUGIN_LIST, catchErrors, sendRequest, connection);
}
